import { HStack, Stack } from "@chakra-ui/react";
import React from "react";

import { CustomerSubTabs } from "./CustomerSubTabs";
import { Events } from "../ui/Events";
import { Notes } from "../ui/Notes";
import { Project } from "./Project";
import { Summary } from "./Summary";

export const CustomerProjects: React.FC<{}> = () => {
  return (
    <>
      <Summary />
      <Stack bg="white" boxShadow="sm" w="full" px="6">
        <CustomerSubTabs />
      </Stack>
      <HStack w="full" spacing="4" alignItems="start">
        <Stack w="75%" spacing="4">
          <Project />
        </Stack>
        <Stack w="25%" spacing="4">
          <Notes />
          <Events />
        </Stack>
      </HStack>
    </>
  );
};
